'use client'

import React, { useState, cloneElement } from "react"
import {
    Outlet,
} from "react-router-dom"

import {
    HamburgerMenu,
} from "../../icons"

type Props = {
    menu: React.JSX.Element
    /** Conservé pour compatibilité : la barre du haut porte désormais son propre style */
    headerClassName?: string
}

export function Layout({
    menu,
}: Props) {

    const [open, setOpen] = useState(false)

    return (
        <div className="w-screen h-screen flex flex-col layout z-0">
            <header className={`menu-shell select-none ${open ? 'menu-open' : ''}`}>
                <button
                    type="button"
                    aria-label="Menu"
                    aria-expanded={open}
                    className="menu-burger md:hidden"
                    onClick={ () => { setOpen(!open) } }
                >
                    <HamburgerMenu className="fill-current w-5 h-5" />
                </button>
                { cloneElement(menu, { setOpen }) }
            </header>
            <main className="flex-1 overflow-auto relative z-0 scrollbar">
                <div className="mx-auto w-full max-w-[1480px]">
                    <Outlet />
                </div>
            </main>
        </div>
    )
}
